import { __extends } from "tslib";
import { ListDocumentClassificationJobsRequest, ListDocumentClassificationJobsResponse } from "../models/models_0";
import { deserializeAws_json1_1ListDocumentClassificationJobsCommand, serializeAws_json1_1ListDocumentClassificationJobsCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var ListDocumentClassificationJobsCommand = /** @class */ (function (_super) {
    __extends(ListDocumentClassificationJobsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function ListDocumentClassificationJobsCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    ListDocumentClassificationJobsCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "ComprehendClient";
        var commandName = "ListDocumentClassificationJobsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: ListDocumentClassificationJobsRequest.filterSensitiveLog,
            outputFilterSensitiveLog: ListDocumentClassificationJobsResponse.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ListDocumentClassificationJobsCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1ListDocumentClassificationJobsCommand(input, context);
    };
    ListDocumentClassificationJobsCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1ListDocumentClassificationJobsCommand(output, context);
    };
    return ListDocumentClassificationJobsCommand;
}($Command));
export { ListDocumentClassificationJobsCommand };
//# sourceMappingURL=ListDocumentClassificationJobsCommand.js.map